import React from 'react';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const createData = (heading, col1, col2) => {
    return { heading, col1, col2 };
  }
  
const tableComparisonData = [
  createData('Focus', 'Academic enrichment and skill development',
              'Recreational activities and personal development'),
  createData('Content', 'Structured courses in various academic subjects',
              'Diverse activities (sports, games, sightseeing, etc.)'),
  createData('Participants', 'Students seeking academic advancement or exploration',
              'Children and teenagers looking for fun and social interaction'),
  createData('Learning Environment', 'Held in world-leading universities, learning from expert tutors from these institutions',
              'Locations are not necessarily universities; can also be held in other suitable venues'),
  createData('Outcome', 'Better prepared for university, with opportunities to find inspiration in their academic pursuits',
              'New experiences, friendships, and personal growth'),
];

const StyledTableCell = styled(TableCell)({
  border: '1px black solid'
});

const ComparisonDesktop = () => {
  return (
    <TableContainer sx={{ width: '90%' }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Academic Summer School</StyledTableCell>
            <StyledTableCell sx={{ fontWeight: 'bold' }} align="left">Summer Camp</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableComparisonData.map((row) => (
            <TableRow
              key={row.heading}
            >
              <StyledTableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                {row.heading}
              </StyledTableCell>
              <StyledTableCell align="left">{row.col1}</StyledTableCell>
              <StyledTableCell align="left">{row.col2}</StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
  
export default ComparisonDesktop;
